// extracted by mini-css-extract-plugin
export default {"wrapper":"Details_wrapper__LkDpd","title":"Details_title__Vhasq","cards":"Details_cards__uX8HR","loader":"Details_loader__mdhP-"};